import { Box, Button, Grid, TextField } from '@material-ui/core';

import { Autocomplete } from '@material-ui/lab';

import { Loader } from 'components/loader/loader';
import React, { useMemo } from 'react';

import { useFormikContext } from 'formik';
import { UseQueryResult } from 'react-query';
import { Result } from 'types';
import SearchRadioGroup from './search-radio-group';
import { NewCentralFormType } from '../types';
import ClearIcon from '@material-ui/icons/Clear';

type Item = { id: string; name: string; evidenceNumber?: string };
type Props<T extends unknown> = {
  useList: () => UseQueryResult<Result<T>, unknown>;
  labelInclude: string;
  labelExclude: string;
  formKey: 'selectedCollections' | 'selectedAids';
  label: string;
  placeholder: string;
};

const SearchSelectWithRadioRemote = <T,>({
  useList,
  label,
  labelExclude,
  labelInclude,
  formKey,
  placeholder,
}: Props<T>) => {
  const response = useList();
  const { values, setFieldValue } = useFormikContext<NewCentralFormType>();
  const options = useMemo(() => {
    if (response.isSuccess) {
      return (((response?.data?.items ?? []) as unknown) as Item[]).map(
        ({ id, name, evidenceNumber }) => ({
          id,
          label: `${name ?? ''} (č. ${evidenceNumber})`,
        })
      );
    } else {
      return [];
    }
  }, [response?.data?.items, response.isSuccess]);

  if (response.isLoading) {
    return <Loader />;
  }

  return (
    <Grid item xs={12}>
      <Box
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        display="flex"
      >
        <SearchRadioGroup
          label={label}
          name={`${formKey}.operation`}
          options={[
            { label: labelInclude, value: 'include' },
            { label: labelExclude, value: 'exclude' },
          ]}
        />

        {values[formKey].items.length > 0 && (
          <Button
            onClick={() => {
              setFieldValue(`${formKey}.items`, []);
            }}
          >
            <ClearIcon fontSize="small" />
            Zrušit výběr
          </Button>
        )}
      </Box>
      <Autocomplete
        autoComplete
        options={options}
        getOptionLabel={(option) => option.label}
        defaultValue={[]}
        disableClearable
        multiple
        noOptionsText="Žádné další možnosti"
        filterSelectedOptions
        value={values[formKey].items}
        onChange={(_, item) =>
          item && setFieldValue(`${formKey}.items`, [...item])
        }
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={'Přidat / ubrat položky'}
            label={
              values[formKey].items.length === 0
                ? placeholder
                : values[formKey].operation === 'include'
                ? labelInclude
                : labelExclude
            }
            variant="outlined"
            id={`${formKey}.items`}
          />
        )}
      />
    </Grid>
  );
};

export default SearchSelectWithRadioRemote;
